// includes new-match, notify, external, not-found

const common = {
  addMatches: 'Add Matches',
  editMatch: 'Edit Match',
  deleteMatch: 'Delete Match',
  deleteMatchDesc:
    "Are you sure you want to delete this match? Once deleted you can't restore this match again and it will be removed from player profiles and from the club matches page.",
  externalMatchManaged:
    'This match was uploaded on an external platform and must be edited or deleted there.',
  oldPass: 'Old Password',
  newPass: 'New Password',
  confirmPass: 'Confirm Password',
  save: 'Save',
  firstName: 'First Name',
  lastName: 'Last Name',
  location: 'Location',
  yourBirthday: 'Your Birthday',
  birthday: 'Birthday',
  birthDateMin: 'To create an account for a user under 13 years of age please complete the form below:',
  under13AccountCreationForm: 'Account Creation Request Form',
  gender: 'Gender',
  phone: 'Phone',
  yourPhone: 'Your Phone',
  congrats: 'Congratulations!',
  error: 'Error',
  search: 'Search',
  filters: 'Filters',
  apply: 'Apply',
  clearAll: 'Clear All',
  distance: 'Distance',
  noLimit: 'No limit',
  man: 'Man',
  woman: 'Woman',
  anybody: 'Anybody',
  men: 'Men',
  women: 'Women',
  type: 'Type',
  doubles: 'Doubles',
  singles: 'Singles',
  Doubles: 'Doubles',
  Singles: 'Singles',
  Any: 'Any',
  duprRating: 'DUPR Rating',
  ageRange: 'Age Range',
  minAge: 'Min Age',
  maxAge: 'Max Age',
  under19: 'Under 19',
  share: 'Share',
  message: 'Message',
  messages: 'Messages',
  email: 'Email',
  emailPlaceHolder: 'Enter Email',
  confirmEmail: 'Confirm Email',
  confirmEmailPlaceHolder: 'Enter Confirm Email',
  password: 'Password',
  passwordPlaceHolder: 'Enter Password',
  confirmPassword: 'Confirm Password',
  confirmPasswordPlaceHolder: 'Enter Confirm Password',
  fullName: 'Full Name',
  fullNamePlaceHolder: 'Enter Full Name',
  birthDate: 'Birth Date',
  birthDatePlaceHolder: 'Choose Birth Date',
  phonePlaceHolder: 'Enter Phone',
  continue: 'Continue',
  selectCountry: 'Select the country',
  submit: 'Submit',
  forgotPassword: 'Forgot Password',
  cancel: 'Cancel',
  textDigitCode: 'Enter Your 4 Digit Code',
  resend: 'Resend',
  verify: 'Verify',
  noMoreResults: 'No more results.',
  contactSupport: 'Contact Support',
  viewAll: 'View All',
  payments: 'Payments',
  setUpPayments: 'Set Up Payments',
  details: 'Details',
  navigate: 'Navigate',
  member: 'Member',
  members: 'Members',
  exportCSV: 'Export CSV',
  exportFailed: "We couldn't export your members. Please try again.",
  exportTimedOut: 'Your export is taking longer than expected. Please try again shortly.',
  exportConnectionLost: 'We lost the connection while preparing your export. Please try again.',
  downloadCSVDesc: 'Download our CSV template to create a bulk invite using emails.',
  downloadCSVNote: 'NOTE: You need to remove the header of the CSV file',
  learnMore: 'Learn More',
  downloadTemplate: 'Download Template',
  dragFile: 'Drag your CSV file here or',
  browseFile: 'Browse Files',
  removeFile: 'Remove file',
  matches: 'Matches',
  match: 'Match',
  sort: 'Sort',
  newToOld: 'Newest to Oldest',
  oldToNew: 'Oldest to Newest',
  clearFilters: 'Clear Filters',
  matchId: 'Match ID:',
  reUpload: 'Re-Upload',
  events: 'Events',
  deleteEvent: 'Delete Event',
  deleteEventDesc:
    'Deleting this event will also delete the bracket(s) associated with it. Confirm to delete this event.',
  confirm: 'Confirm',
  delete: 'Delete',
  registeredPlayers: 'Registered Players',
  upcoming: 'Upcoming',
  draft: 'Draft',
  open: 'Open',
  ongoing: 'Ongoing',
  completed: 'Completed',
  logo: 'Logo',
  eventLogo: 'Event Logo',
  eventName: 'Event Name',
  registration_url: 'Registration URL',
  summary: 'Summary',
  whatAreTheDetails: 'What are the details?',
  entryFee: 'Entry Fee',
  entryFeeDesc:
    'Players will pay this entry fee on top of their bracket fee. You can set the per bracket fee price later.',
  memberPrice: 'Member Price',
  nonMemberPrice: 'Non-member Price',
  policies: 'Policies',
  uploadWaiver: 'Upload Waiver',
  uploadWaiverDesc: 'DUPR encourages events to include a liability waiver.',
  liabilityWaiver: 'Liability Waiver',
  refundPolicy: 'Refund Policy',
  refundPolicyDesc:
    'Will registrants receive a full or partial refund if they cancel before the event has begun? Will they receive a partial refund if they cancel after the league is initiated?',
  healthPolicy: 'Health Policy',
  healthPolicyDesc: 'Will your league have specific rules regarding the health and safety of participants?',
  bracket: 'Bracket',
  brackets: 'Brackets',
  addBracket: 'Add Bracket',
  select: 'Select',
  playerGroup: 'Player Group',
  format: 'Format',
  ratingRange: 'Rating Range',
  minimum: 'Minimum',
  maximum: 'Maximum',
  name: 'Name',
  bracketName: 'Bracket Name',
  autoGenerate: 'Auto Generate',
  courts: 'Courts',
  courtsDesc: 'Number of Courts (Minimum 1 and Maximum 8)',
  maxTeams: 'Max Teams',
  maxTeamsDec: 'How many teams will participate in the event?',
  waitList: 'Waitlist',
  waitListDesc: 'How many teams would you like to permit to join the waitlist?',
  registration: 'Registration',
  registrationDesc: 'Set the duration that players can register for',
  startDateTime: 'Start Date & Time',
  endDateTime: 'End Date & Time',
  competition: 'Competition',
  competitionDesc: 'Set the date and time for this bracket’s competition',
  timeZone: 'Time Zone',
  price: 'Price',
  priceDesc: 'Players will pay this as well as the entry fee',
  selectAnImage: 'Select an image to upload',
  loadingImage: 'Loading image...',
  chooseFile: 'Choose File',
  invite: 'Invite',
  optional: '(Optional)',
  messageAndDataRatesMayApply: 'Message and data rates may apply.',
  sendInvite: 'Send Invite',
  invites: 'Invites',
  requests: 'Requests',
  invited: 'Invited',
  ignoreAll: 'Ignore All',
  acceptAll: 'Accept All',
  ignore: 'Ignore',
  cancelInvite: 'Cancel Invite',
  address: 'Address',
  addNew: 'Add New',
  mi: 'Mi',
  startsIn: 'Starts in',
  endsIn: 'Ends in',
  downloadLiabilityWaiver: 'Download Liability Waiver',
  healthSafetyPolicy: 'Health & Safety Policy',
  yes: 'Yes',
  no: 'No',
  addPartner: 'Add Partner',
  addPartnerNote: 'You can also wait until after registration to add a partner',
  ok: 'OK',
  success: 'Success',
  failure: 'Failure',
  signUpOrLogin: 'Sign Up or Log in to view this information',
  accept: 'Accept',
  goBack: 'Go Back',
  with: 'with',
  game: 'Game',
  highToLowRating: 'High to Low Rating',
  lowToHighRating: 'Low to High Rating',
  add: 'Add',
  confirmation: 'Confirmation',
  back: 'Back',
  next: 'Next',
  saveChanges: ' Save Changes',
  sortingRules: 'Sorting Rules',
  sortingRulesDesc:
    'Teams are sorted by average rating. Verified ratings are weighted more heavily than provisional ratings. Players with an NR rating are considered to be rated as a 2.00.',
  create: 'Create',
  matchDate: 'Match Date',
  time: 'Time',
  connectWith: 'Connect With',
  externalApplication: "The world's most accurate pickleball rating",
  externalLoginCheckbox:
    'Allow DUPR to create a new session for this site using a read only access, all my data will be protected and secure',
  logging: 'Logging In...',
  login: 'Login',
  saveMatch: 'Save Match',
  submitMatches: 'Submit Matches',
  confirmSubmitMatches: 'These matches will be submitted and player ratings will update shortly.',
  event: 'Event',
  eventPlaceHolder: 'Event Name',
  date: 'Date',
  checkboxAddYourSelf: 'Add yourself as player in this match?',
  team1: 'Team 1',
  team2: 'Team 2',
  searchPlayer: 'Search Player',
  score: 'Score',
  standard: 'Standard',
  rally: 'Rally',
  game1: 'Game 1',
  game2: 'Game 2',
  game3: 'Game 3',
  game4: 'Game 4',
  game5: 'Game 5',
  addAnotherMatch: 'Add Another Match',
  oops: 'Oops!',
  venturedPath: "You've ventured off the path.",
  redirectedDashboard: 'You will be redirected to Dashboard in',
  seconds: 'seconds',
  DUPRIDCopied: 'DUPRID Copied!',
  copyClipboard: 'Copy to clipboard',
  myAccount: 'My Account',
  editProfile: 'Edit Profile',
  passwordSecurity: 'Password and Security',
  infoSupport: 'Info and Support',
  support: 'Support',
  runEvents: 'Run Events',
  FAQs: 'FAQs',
  termsUse: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  logout: 'Logout',
  warning: 'WARNING',
  reset: 'Reset',
  Members: 'Members',
  Matches: 'Matches',
  Events: 'Events',
  Invites: 'Invites',
  Queue: 'Queue',
  Standings: 'Standings',
  Players: 'Players',
  Teams: 'Teams',
  UnmatchedPlayer: 'Unmatched Player',
  Payments: 'Payments',
  performance: 'Performance',
  myPerformance: 'My Performance',
  newMatch: 'New Match',
  players: 'Players',
  clubs: 'Clubs',
  Week: 'Week',
  Month: 'Month',
  RoundRobin: 'Round Robin',
  Waterfall: 'Waterfall',
  FlexLeague: 'Flex League',
  Mixed: 'Mixed',
  Open: 'Open',
  Men: 'Men',
  Women: 'Women',
  ViewAll: 'View All',
  Round: 'Round',
  Round1: 'Round 1',
  Round2: 'Round 2',
  Round3: 'Round 3',
  Round4: 'Round 4',
  Round5: 'Round 5',
  Round6: 'Round 6',
  Round7: 'Round 7',
  Round8: 'Round 8',
  Round9: 'Round 9',
  Round10: 'Round 10',
  Dashboard: 'Dashboard',
  SearchPlayer: 'Search Player',
  SearchEvents: 'Search Events',
  Rankings: 'Rankings',
  Genie: 'Genie',
  Shops: 'Shops',
  HowItWorks: 'How It Works',
  RunEvents: 'Run Events',
  CollegiatePickleball: 'Collegiate Pickleball',
  News: 'News',
  LogIn: 'Log In',
  SignUp: 'Sign Up',
  decline: 'Decline',
  savePublish: 'Save & Publish',
  publish: 'Publish',
  publishing: 'Publishing',
  upload: 'Upload',
  signUpLogin: 'Sign Up or Login',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  following: 'Following',
  followers: 'Followers',
  rating: 'Rating',
  MatchDate: 'Match Date',
  CreatedDate: 'Created Date',
  ModifiedDate: 'Modified Date',
  follow: 'Follow',
  unFollow: 'Unfollow',
  noFollowing: "This player isn't following anyone yet",
  noFollower: "This player doesn't have any followers yet",
  notFollowing: 'This player isn’t following anyone yet',
  home: 'Home',
  removeConfirm: 'Are you sure that you want to remove this?',
  edit: 'Edit',
  play: 'Play',
  invitePlayerSuccess: 'Add member success',
  createAMatch: 'Create A Match',
  marketingAssets: 'Club Resources',
  settings: 'Settings',
  compliantText:
    'By checking this box you agree you would like to receive more information regarding our product updates, events, news and offers',
  communityGuidelines: 'Community Guidelines',
  minorLeaguePickleball: 'Minor League',
  collegiatePickleball: 'Collegiate',
  blog: 'Blog',
  playerName: 'Player Name',
  addMembers: 'Add Group Members',
  verifyEmail: 'Verify your Email',
  mustVerify: 'You must verify your email to access the site.',
  clickResendLink: 'Click "resend link" to receive a verification link.',
  changeEmail: 'Would you like to change your email?',
  alreadyVerified: 'Already Verified',
  resendLink: 'Resend Link',
  aLinkWasSent: 'A link was sent to your new email!',
  matchOwner: 'Match Owner',
  hasVerifiedMatch: 'The player has verified the match',
  firstNamePlaceHolder: 'Enter First Name',
  lastNamePlaceHolder: 'Enter Last Name',
  removed: 'Removed',
  today: 'Today',
  yesterday: 'Yesterday',
  privacy: 'Privacy',
  displayAge: 'Display Age',
  hideAge: 'Hide Age',
  displayLocation: 'Display Location',
  hideLocation: 'Hide Location',
  doNotTrack: 'Do Not Track',
  allowTracking: 'Allow Tracking',
  allowTargetedAds: 'Allow Targeted Ads',
  disallowTargetedAds: 'Disallow Targeted Ads',
  subscriptions: 'Subscriptions',
  manageSubscription: 'Manage Subscription',
  haveActiveSubscription: 'You have an active DUPR+ subscription.',
  toManageSubscription: 'To manage your subscription, please',
  visitThisLinkTo: 'Visit this link to',
  subscriptionStatus: 'Subscription Status',
  and: 'and',
  phoneVerify:
    'By entering my mobile number, I agree to receive text messages for account verification and two-factor authentication (2FA). Standard message and data rates may apply. These messages are used solely to help secure my account and verify my identity and not for marketing',
  phoneOptInRequired:
    'You must agree to the text message opt-in for account verification and two-factor authentication above.',
  verifyYourPhone: 'Verify your phone',
  sentCodeTo: 'We sent a code to {{phone}}',
  sendCodeTo: 'Send a code to {{phone}}',
  phoneVerified: 'Phone number verified',
  youreAllSet: 'You’re all set.',
  sending: 'Sending...',
  sendCode: 'Send code',
  verifying: 'Verifying...',
  resendIn: 'Resend in {{s}}s',
  resendCode: 'Resend code',
  otpDisclaimer: 'Standard messaging rates may apply.',
  invalidCode: 'Invalid code, try again.',
  genericError: 'Something went wrong. Please try again.',
  phoneMissing: 'No phone number to verify.',
  verifyingNumber: 'Verifying number',
  iso: 'ISO',
  changeNumber: 'Change number',
}

export type LocaleCommon = typeof common

export default common
